import { useContext } from "react";
import { GoftinoContext } from "./index";

export const useGoftino = () => {
  const context = useContext(GoftinoContext);

  if (!context) {
    throw new Error("useGoftino must be used within a Goftino Provider.");
  }

  return context;
};
